import React from 'react';
import './Fotter.css';
import logo from '../../footerLogo.png';
import FacebookIcon from 'react-icons/lib/io/social-facebook';
import YoutubeIcon from 'react-icons/lib/io/social-youtube';
import InstaIcon from 'react-icons/lib/io/social-instagram';
import TwitterIcon from 'react-icons/lib/io/social-twitter';

class Footer extends React.Component{

    render(){
        return(
        <React.Fragment>
            <footer>
                <div className="footer-wrapper cairo-font">
                    <div>
                        <h2>عنوان المركز</h2>
                        <p>شارع السوق الحى الثامن -مدينة نصر‏‏</p>
                        <img src="https://mhesham32cdn.netlify.com/img/elmohandess/draw-map.png" alt=""/>
                    </div>
                    <div>
                        <h2>الهواتف</h2>
                        <h3>{" "+224727794} :المركز</h3>
                        <h3>مهندس/موسى</h3>
                        <p>01222811311</p>
                        <h3>مهندس/ابراهيم</h3>
                        <p>01115136318</p>
                        <p>01065246803</p>
                    </div>
                    <div>
                       <h2>مركز المهندس</h2>
                       <h3 className="lemo-font">المهندس*علم*جودة*تميز</h3>
                       <a href="/"><img src={logo} alt=""/></a>
                    </div>
                    <div>
                        <h2>تواصل معنا </h2>
                        <div className="footer-social">
                        <a href="https://www.facebook.com/Elmuhandis-Auto-138797603583040/">
                <span className="facebook"><FacebookIcon/></span></a>
                <a href="https://www.facebook.com/Elmuhandis-Auto-138797603583040/">
                <span className="insta"><InstaIcon/></span></a>
                <a href="https://www.facebook.com/Elmuhandis-Auto-138797603583040/">
                <span className="twitter"><TwitterIcon/></span></a>
                <a href="https://www.facebook.com/Elmuhandis-Auto-138797603583040/">
                <span className="youtube"><YoutubeIcon/></span></a>
                        </div>
                    </div>
                </div>
            </footer>
            <CopyRights/>
        </React.Fragment>
        );
    }
}

export default Footer;

const CopyRights = ()=>{
    return(
        <div className="copy-rights cairo-font ">
            <div className="place">© جميع الحقوق محفوظة لمركز المهندس 2018</div>
            <div className="mostafa">
                <a href="https://mostafahesham.xyz/"> Mostafa Hesham </a>
                 برمجة وتصميم 
            </div>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/footer/Fotter.js